module.exports = __webpack_public_path__ + "img/1071922623.18b8d4aa.jpg";